import { get, writable } from "svelte/store";
import { v4 as uuid } from "uuid";

/**
 * Create a store saved to LocalStorage.
 * @param {string} key
 */
function persistent(key) {
	const { set, subscribe } = writable(
		import.meta.env.SSR ? null : JSON.parse(localStorage.getItem(key) || null),
	);

	return {
		subscribe,
		set: (value) => {
			localStorage.setItem(key, JSON.stringify(value));
			set(value);
		},
		/** Remove the item from LocalStorage. Store remains intact. */
		delete: () => localStorage.removeItem(key),
	};
}

const anonUserId = writable();
/** @returns {string} */
export const getAnonUserId = () => {
	let id = get(anonUserId);
	if (!id) {
		id = localStorage.getItem("anonUserId");
		if (!id) {
			id = uuid();
			localStorage.setItem("anonUserId", id);
		}
		anonUserId.set(id);
	}
	return id;
};

const sessionId = writable();
/** @returns {string} */
export const getSessionId = () => {
	if (!get(sessionId)) sessionId.set(uuid());
	return get(sessionId);
};

/** @type {import("svelte/store").Writable<{class: string, fn: (element: HTMLElement) => void}[]>} */
export const utilityButtons = writable([]);

/** @type {import("svelte/store").Writable<{id: string, fullScale: boolean, tableScale: boolean, options: Array}>} */
export const selectedPlan = writable();
